
        // No URL sort means no selected sort. Do not resurrect a previous
        // Weight/native choice from sessionStorage after a full page load.
        // This keeps direct URLs behaving exactly like Shopify native URLs.
class Toolbar extends HTMLElement {
    constructor() {
        super();

        // ============================================================
        // PRAMOGH WEIGHT SORT — STATE
        // ============================================================

        this.pramoghWeightLoading = false;
        this.pramoghWeightRequestId = 0;
        this.pramoghWeightAbortController = null;
        this.pramoghWeightCardCache = new Map();
        this.pramoghWeightCardInFlight = new Map();
        this.pramoghWeightBackgroundToken = 0;
        this.pramoghWeightProductsCache = null;
        this.pramoghWeightDirection = null;
        this.pramoghWeightFilterKey = null;
        this.pramoghWeightPaginationBound = false;

        // ============================================================
        // PRAMOGH GENERIC SORT STATE
        // ============================================================

        this.pramoghSortStoragePrefix =
            'pramogh_collection_sort_state:';

        // PRAMOGH WEIGHT SORT is authoritative across Shopify's
        // filter/AJAX lifecycle. The toolbar element itself can be
        // destroyed and recreated, so never use the element instance
        // as the source of truth.
        this.initializePramoghAuthoritativeWeightState();

        // A filter can still cause a hard navigation in some theme
        // paths. In that case the browser URL may contain Shopify's
        // temporary sort_by value even though Weight was the user's
        // last explicit selection. Restore the pending user choice
        // before reading the URL as the active sort.
        this.restorePramoghPendingFilterSortState();

        this.pramoghSortState =
            this.getPramoghSortStateFromURL();

        // If Weight is active globally, keep it authoritative even when
        // Shopify temporarily exposes sort_by=manual/best-selling.
        const authoritativeWeight =
            this.getPramoghAuthoritativeWeightState();
        if (authoritativeWeight) {
            this.pramoghSortState = {
                type: 'weight',
                value: authoritativeWeight
            };
        }

        this.pramoghSaveCurrentSortState();

        const collectionProductGrid =
            document.getElementById(
                'CollectionProductGrid'
            );

        this.stickyBounds =
            collectionProductGrid
                ? collectionProductGrid.querySelector(
                      '.productListing'
                  )
                : null;

        this.queryParams();
        this.closeModalClick();

        // Weight sort owns pagination only while it is active.
        // Event delegation keeps this working after AJAX/filter DOM replacement.
        this.bindPramoghWeightPagination();

        // ============================================================
        // VIEW MODE
        // ============================================================

        if (this.querySelector('[data-view-as]')) {
            this.mediaView =
                this.querySelector(
                    '[data-view-as]'
                );

            this.mediaViewMobile =
                this.querySelector(
                    '[data-view-as-mobile]'
                );

            this.mediaView
                .querySelectorAll('.icon-mode')
                .forEach((modeButton) => {
                    modeButton.addEventListener(
                        'click',
                        this.onClickModeButtonHandler.bind(
                            this
                        )
                    );
                });

            if (this.mediaViewMobile) {
                this.mediaViewMobile
                    .querySelectorAll('.icon-mode')
                    .forEach(
                        (
                            modeMobileButton
                        ) => {
                            modeMobileButton.addEventListener(
                                'click',
                                this.onClickModeButtonMobileHandler.bind(
                                    this
                                )
                            );
                        }
                    );
            }

            this.debouncedOnResizeMediaQuery =
                debounce(() => {
                    this.setActiveViewModeMediaQuery(
                        false
                    );
                }, 200);

            var w = window.innerWidth;

            window.addEventListener(
                'resize',
                () => {
                    if (
                        window.innerWidth ==
                        w
                    ) {
                        return;
                    }

                    w = window.innerWidth;

                    this.debouncedOnResizeMediaQuery();
                }
            );

            window.addEventListener(
                'load',
                () => {
                    this.debouncedOnResizeMediaQuery();
                }
            );
        }

        // ============================================================
        // PRODUCTS PER PAGE
        // ============================================================

        if (
            this.querySelector(
                '[data-limited-view]'
            )
        ) {
            this.limitView =
                this.querySelector(
                    '[data-limited-view]'
                );

            this.limitView
                .querySelectorAll(
                    '[data-limited-view-item]'
                )
                .forEach((limitButton) => {
                    limitButton.addEventListener(
                        'click',
                        this.onClickLimitButtonHandler.bind(
                            this
                        )
                    );
                });
        }

        // ============================================================
        // DROPDOWNS
        // ============================================================

        if (
            this.querySelector('[data-toggle]')
        ) {
            this.querySelectorAll(
                '[data-toggle]'
            ).forEach(
                (dropdownButton) => {
                    dropdownButton.addEventListener(
                        'click',
                        this.onClickDropdownButtonHandler.bind(
                            this
                        )
                    );
                }
            );

            window.addEventListener(
                'load',
                () => {
                    document.body.addEventListener(
                        'click',
                        this.onBodyClickEvent.bind(
                            this
                        )
                    );
                }
            );
        }

        // ============================================================
        // SORTING
        // ============================================================

        // Save the explicit sort before ANY filter control is allowed to
        // navigate or submit. This is the last line of defense for theme
        // filter paths that bypass CollectionFiltersForm and perform a
        // normal browser navigation.
        this.bindPramoghFilterSortGuard();

        if (
            this.querySelector('[data-sorting]')
        ) {
            this.bindSortingEvents();
        }

        // The custom topbar <select id="collection-sort-by"> lives
        // inside the collection markup and is replaced on every filter
        // AJAX render. Bind once at document level so the new select is
        // always handled without relying on an inline script executing
        // after innerHTML replacement.
        this.bindPramoghTopbarSortSelect();

        // ============================================================
        // INITIAL WEIGHT SORT LOAD
        // ============================================================
        // A hard reload can arrive with ?pramogh_weight_sort=asc|desc.
        // Shopify has no knowledge of this custom parameter, so the
        // server-rendered grid is NOT the sorted grid. Run the backend
        // sorter immediately from the URL on every direct page load.
        this.initializePramoghWeightSortFromURL();

        // ============================================================
        // CURRENCY
        // ============================================================

        if (this.checkNeedToConvertCurrency()) {
    const convertCurrency = () => {
        if (
            typeof Currency !== 'undefined' &&
            typeof Currency.convertAll === 'function'
        ) {
            Currency.convertAll(
                window.shop_currency,
                $('#currencies .active').attr(
                    'data-currency'
                ),
                'span.money',
                'money_format'
            );
        }
    };

    if ('requestIdleCallback' in window) {
        requestIdleCallback(convertCurrency, {
            timeout: 2000
        });
    } else {
        setTimeout(convertCurrency, 1000);
    }
}

        // ============================================================
        // RESTORE SORT STATE
        // ============================================================

        if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
        this.restorePramoghWeightToolbarState();
    }, {
        timeout: 1500
    });
} else {
    setTimeout(() => {
        this.restorePramoghWeightToolbarState();
    }, 500);
}
    }

    // ================================================================
    // INITIAL WEIGHT SORT LOAD
    // ================================================================

    initializePramoghWeightSortFromURL() {
        const url = new URL(window.location.href);
        const direction = url.searchParams.get('pramogh_weight_sort');

        if (direction !== 'asc' && direction !== 'desc') {
            return;
        }

        this.savePramoghSortState('weight', direction);
        this.setPramoghWeightToolbarState(direction);

        // Do not rewrite the URL during a hard load. The URL is already
        // the canonical filter + weight state.
        this.loadPramoghWeightSort(
            direction,
            parseInt(url.searchParams.get('page') || '1', 10) || 1,
            false,
            url.href
        );
    }

    // ================================================================
    // ACTIVATE WEIGHT SORT
    // ================================================================

    activatePramoghWeightSort(direction, page = 1) {
        if (direction !== 'asc' && direction !== 'desc') {
            return;
        }

        // Commit Weight ownership BEFORE Shopify/theme code can start
        // a filter/AJAX lifecycle. This state lives outside the toolbar
        // element and therefore survives DOM replacement.
        this.setPramoghAuthoritativeWeightState(direction);
        this.clearPramoghPendingFilterSortState();
        this.savePramoghSortState('weight', direction);

        // Commit the custom state BEFORE the backend request starts.
        // Any filter action during the request therefore sees the new
        // weight direction instead of Shopify's server default sort.
        const url = new URL(window.location.href);
        url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        url.searchParams.set('pramogh_weight_sort', direction);

        history.replaceState(
            { pramoghWeightSort: direction, page: page },
            '',
            url.pathname + url.search
        );

        this.setPramoghWeightToolbarState(direction);
        this.loadPramoghWeightSort(direction, page, false, url.href);
    }

    // ================================================================
    // FILTER SORT GUARD — CAPTURE BEFORE FILTER NAVIGATION
    // ================================================================

    bindPramoghFilterSortGuard() {
        if (window.__PRAMOGH_FILTER_SORT_GUARD_BOUND__) {
            return;
        }

        window.__PRAMOGH_FILTER_SORT_GUARD_BOUND__ = true;

        const captureFilterAction = (event) => {
            const target = event.target;
            if (!target || !target.closest) return;

            const filterControl = target.closest(
                '.js-facet-remove, ' +
                'facet-remove a, ' +
                '.pramogh-active-filter, ' +
                '.price-range-button, ' +
                '.collection-filters__item input, ' +
                '.collection-filters__item select, ' +
                '.filter__price button, ' +
                '#filter__apply-all'
            );

            if (!filterControl) return;

            try {
                const toolbar = document.querySelector('toolbar-item');
                if (toolbar && typeof toolbar.getPramoghCurrentSortState === 'function') {
                    const state = toolbar.getPramoghCurrentSortState();
                    if (state) {
                        // Synchronously lock Weight ownership for the whole
                        // filter transaction. Shopify may generate a native
                        // sort_by remove URL, but it must never replace an
                        // explicitly selected Weight sort.
                        if (state.type === 'weight' &&
                            (state.value === 'asc' || state.value === 'desc')) {
                            window.__PRAMOGH_FILTER_SORT_LOCK__ = state.value;
                        }

                        if (typeof toolbar.savePramoghPendingFilterSortState === 'function') {
                            toolbar.savePramoghPendingFilterSortState(state);
                        }
                    }
                }
            } catch (error) {
                console.warn(
                    'PRAMOGH FILTER SORT GUARD ERROR:',
                    error
                );
            }
        };

        document.addEventListener(
            'click',
            captureFilterAction,
            true
        );

        document.addEventListener(
            'change',
            captureFilterAction,
            true
        );

        document.addEventListener(
            'submit',
            captureFilterAction,
            true
        );
    }

    // ================================================================
    // PRAMOGH TOPBAR SELECT — DYNAMIC/AJAX SAFE
    // ================================================================

    bindPramoghTopbarSortSelect() {
        if (this.pramoghTopbarSortSelectBound) {
            return;
        }

        this.pramoghTopbarSortSelectBound = true;

        document.addEventListener(
            'change',
            (event) => {
                const sortSelect = event.target.closest(
                    '#collection-sort-by'
                );

                if (!sortSelect) {
                    return;
                }

                const selectedValue = sortSelect.value;

                // ----------------------------------------------------
                // CUSTOM WEIGHT SORT
                // ----------------------------------------------------
                if (
                    selectedValue === 'pramogh-weight-asc' ||
                    selectedValue === 'pramogh-weight-desc'
                ) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (event.stopImmediatePropagation) {
                        event.stopImmediatePropagation();
                    }

                    const direction =
                        selectedValue === 'pramogh-weight-desc'
                            ? 'desc'
                            : 'asc';

                    // Start from page 1 whenever the sort itself changes.
                    this.activatePramoghWeightSort(direction, 1);

                    return;
                }

                // ----------------------------------------------------
                // NORMAL SHOPIFY SORT
                // ----------------------------------------------------
                // Selecting a native sort explicitly hands ownership
                // back to Shopify. Remove the custom weight state first
                // so both sort systems can never be active together.
                event.preventDefault();
                event.stopPropagation();
                if (event.stopImmediatePropagation) {
                    event.stopImmediatePropagation();
                }

                if (!selectedValue) {
                    return;
                }

                // This is the ONLY path that intentionally hands sort
                // ownership back to Shopify. Filter/AJAX operations must
                // never clear the authoritative Weight state.
                this.clearPramoghAuthoritativeWeightState();
                this.clearPramoghPendingFilterSortState();

                this.savePramoghSortState(
                    'native',
                    selectedValue
                );

                // Hand sort ownership back to Shopify.
                this.setPramoghFilterFormSortState(
                    'native',
                    selectedValue
                );

                Shopify.queryParams =
                    Shopify.queryParams || {};
                Shopify.queryParams.sort_by =
                    selectedValue;
                delete Shopify.queryParams.pramogh_weight_sort;
                delete Shopify.queryParams.page;

                const nativeUrl =
                    new URL(window.location.href);

                nativeUrl.searchParams.delete(
                    'pramogh_weight_sort'
                );
                nativeUrl.searchParams.delete('page');
                nativeUrl.searchParams.set(
                    'sort_by',
                    selectedValue
                );

                window.location.href =
                    nativeUrl.pathname +
                    '?' +
                    nativeUrl.searchParams.toString();
            },
            true
        );

        this.syncPramoghTopbarSortSelect();
    }

    // Keep the custom select aligned with the actual URL/state after
    // every AJAX replacement. The server-rendered select cannot use
    // pramogh_weight_sort as Shopify's native sort_by value.
    syncPramoghTopbarSortSelect(direction = null) {
        const sortSelect =
            document.getElementById('collection-sort-by');

        if (!sortSelect) {
            return;
        }

        let state = this.getPramoghSortStateFromURL();

        if (
            direction === 'asc' ||
            direction === 'desc'
        ) {
            state = {
                type: 'weight',
                value: direction
            };
        }

        if (!state) {
            return;
        }

        let targetValue = null;

        if (state.type === 'weight') {
            targetValue =
                state.value === 'desc'
                    ? 'pramogh-weight-desc'
                    : 'pramogh-weight-asc';
        } else if (state.type === 'native') {
            targetValue = state.value;
        }

        if (!targetValue) {
            return;
        }

        const matchingOption = Array.from(
            sortSelect.options
        ).find(
            (option) => option.value === targetValue
        );

        if (matchingOption) {
            sortSelect.value = targetValue;
        }

        // Recalculate the responsive width after the selected text changes.
        sortSelect.dispatchEvent(
            new Event('pramogh:sort-state-sync')
        );
    }

    // ================================================================
    // BIND SORTING EVENTS
    // ================================================================

    bindSortingEvents() {
        this.sortBys =
            this.querySelectorAll(
                '[data-sorting]'
            );

        if (!this.sortBys.length) {
            return;
        }

        const hasItem =
            this.sortBys[0].querySelector(
                '[data-sort-by-item]'
            ) != null;

        // ------------------------------------------------------------
        // Native Shopify sorting
        // ------------------------------------------------------------

        if (hasItem) {
            this.sortBys.forEach(
                (sortBy) => {
                    sortBy
                        .querySelectorAll(
                            '[data-sort-by-item]'
                        )
                        .forEach(
                            (
                                sortByButton
                            ) => {
                                sortByButton.addEventListener(
                                    'click',
                                    this.onClickSortByButtonHandler.bind(
                                        this
                                    )
                                );
                            }
                        );
                }
            );
        }

        // ------------------------------------------------------------
        // Pramogh Weight sorting
        // ------------------------------------------------------------

        this.sortBys.forEach(
            (sortBy) => {
                sortBy
                    .querySelectorAll(
                        '[data-pramogh-weight-sort]'
                    )
                    .forEach(
                        (
                            weightButton
                        ) => {
                            weightButton.addEventListener(
                                'click',
                                this.onClickPramoghWeightSortHandler.bind(
                                    this
                                )
                            );
                        }
                    );
            }
        );
    }

    // ================================================================
    // QUERY PARAMS
    // ================================================================

    queryParams() {
        Shopify.queryParams = {};

        if (location.search.length > 0) {
            for (
                var aKeyValue,
                    i = 0,
                    aCouples =
                        location.search
                            .substr(1)
                            .split('&');
                i < aCouples.length;
                i++
            ) {
                aKeyValue =
                    aCouples[i].split('=');

                if (
                    aKeyValue.length > 1
                ) {
                    Shopify.queryParams[
                        decodeURIComponent(
                            aKeyValue[0]
                        )
                    ] =
                        decodeURIComponent(
                            aKeyValue[1]
                        );
                }
            }
        }
    }

    // ================================================================
    // GENERIC SORT STATE
    // ================================================================

    // ================================================================
    // AUTHORITATIVE WEIGHT STATE
    // ================================================================

    initializePramoghAuthoritativeWeightState() {
        const pathname = window.location.pathname;

        try {
            const existing = window.__PRAMOGH_WEIGHT_STATE__;

            if (
                existing &&
                existing.pathname === pathname &&
                existing.active === true &&
                (existing.direction === 'asc' || existing.direction === 'desc')
            ) {
                return existing.direction;
            }

            const url = new URL(window.location.href);
            const direction = url.searchParams.get('pramogh_weight_sort');

            if (direction === 'asc' || direction === 'desc') {
                window.__PRAMOGH_WEIGHT_STATE__ = {
                    pathname,
                    active: true,
                    direction
                };
                return direction;
            }
        } catch (error) {
            console.warn('PRAMOGH AUTHORITATIVE WEIGHT INIT ERROR:', error);
        }

        return null;
    }

    getPramoghAuthoritativeWeightState() {
        try {
            const state = window.__PRAMOGH_WEIGHT_STATE__;
            if (
                state &&
                state.pathname === window.location.pathname &&
                state.active === true &&
                (state.direction === 'asc' || state.direction === 'desc')
            ) {
                return state.direction;
            }
        } catch (error) {}

        return null;
    }

    setPramoghAuthoritativeWeightState(direction) {
        window.PramoghWeightController?.set?.(direction);
    }

    clearPramoghAuthoritativeWeightState() {
        window.PramoghWeightController?.clear?.();
    }

    // ---------------------------------------------------------------
    // FILTER NAVIGATION SORT BRIDGE
    // ---------------------------------------------------------------
    // Some filter paths are handled by theme code that can navigate the
    // browser instead of staying inside the AJAX pipeline. Store the
    // user's explicit sort immediately before a filter transaction so
    // that a hard navigation cannot replace Weight with Shopify's
    // temporary/default sort.

    getPramoghPendingFilterSortKey() {
        return (
            this.pramoghSortStoragePrefix +
            'pending:' +
            window.location.pathname
        );
    }

    savePramoghPendingFilterSortState(state = null) {
        const current =
            state || this.getPramoghCurrentSortState();

        if (!current || !current.type || !current.value) {
            return;
        }

        try {
            sessionStorage.setItem(
                this.getPramoghPendingFilterSortKey(),
                JSON.stringify(current)
            );
        } catch (error) {}
    }

    clearPramoghPendingFilterSortState() {
        try {
            sessionStorage.removeItem(
                this.getPramoghPendingFilterSortKey()
            );
        } catch (error) {}
    }

    getPramoghPendingFilterSortState() {
        try {
            const raw = sessionStorage.getItem(
                this.getPramoghPendingFilterSortKey()
            );

            if (!raw) return null;

            const state = JSON.parse(raw);

            if (
                state?.type === 'weight' &&
                (state.value === 'asc' || state.value === 'desc')
            ) {
                return state;
            }

            if (
                state?.type === 'native' &&
                typeof state.value === 'string' &&
                state.value
            ) {
                return state;
            }
        } catch (error) {}

        return null;
    }

    restorePramoghPendingFilterSortState() {
        const pending =
            this.getPramoghPendingFilterSortState();

        if (!pending) return null;

        // The pending marker is only for a filter navigation. Consume it
        // now so it can never override a later unrelated direct visit.
        this.clearPramoghPendingFilterSortState();

        if (pending.type !== 'weight') {
            return pending;
        }

        try {
            const url = new URL(window.location.href);

            // If Weight was explicitly selected before the filter, the
            // filter URL's sort_by is not authoritative. Make Weight the
            // canonical browser state again while preserving every filter.
            url.searchParams.delete('sort_by');
            url.searchParams.set(
                'pramogh_weight_sort',
                pending.value
            );

            window.__PRAMOGH_WEIGHT_STATE__ = {
                pathname: window.location.pathname,
                active: true,
                direction: pending.value
            };

            history.replaceState(
                {
                    pramoghWeightSort: pending.value,
                    restoredFromFilter: true
                },
                '',
                url.pathname + url.search + url.hash
            );
        } catch (error) {
            console.warn(
                'PRAMOGH PENDING FILTER SORT RESTORE ERROR:',
                error
            );
        }

        return pending;
    }

    getPramoghSortStorageKey() {
        return (
            this.pramoghSortStoragePrefix +
            window.location.pathname
        );
    }

    // ---------------------------------------------------------------
    // Read sort state directly from URL
    // ---------------------------------------------------------------

    getPramoghSortStateFromURL(
        url = window.location.href
    ) {
        try {
            var currentUrl =
                new URL(
                    url,
                    window.location.origin
                );

            var weightSort =
                currentUrl.searchParams.get(
                    'pramogh_weight_sort'
                );

            if (
                weightSort === 'asc' ||
                weightSort === 'desc'
            ) {
                return {
                    type: 'weight',
                    value: weightSort
                };
            }

            var nativeSort =
                currentUrl.searchParams.get(
                    'sort_by'
                );

            if (nativeSort) {
                return {
                    type: 'native',
                    value: nativeSort
                };
            }

            return null;
        } catch (error) {
            console.error(
                'PRAMOGH SORT STATE URL ERROR:',
                error
            );

            return null;
        }
    }

    // ---------------------------------------------------------------
    // Save selected sort state
    // ---------------------------------------------------------------

    savePramoghSortState(
        type,
        value
    ) {
        if (
            type !== 'native' &&
            type !== 'weight'
        ) {
            return;
        }

        if (!value) {
            return;
        }

        this.pramoghSortState = {
            type: type,
            value: value
        };

        try {
            sessionStorage.setItem(
                this.getPramoghSortStorageKey(),
                JSON.stringify(
                    this.pramoghSortState
                )
            );
        } catch (error) {
            console.warn(
                'PRAMOGH SORT SESSION STORAGE ERROR:',
                error
            );
        }
    }

    // ---------------------------------------------------------------
    // Save current URL sort state
    // ---------------------------------------------------------------

    pramoghSaveCurrentSortState() {
        // The current URL is authoritative on initial load. During an AJAX
        // filter lifecycle the non-DOM Weight bridge is authoritative.
        const weightDirection =
            window.PramoghWeightController?.getDirection?.();

        if (weightDirection) {
            this.savePramoghSortState('weight', weightDirection);
            return;
        }

        const urlState = this.getPramoghSortStateFromURL();
        if (urlState) {
            this.savePramoghSortState(urlState.type, urlState.value);
            return;
        }

        // No URL sort means Shopify's default/native behavior. Never
        // resurrect an older selection from sessionStorage.
        this.pramoghSortState = null;
    }

    // ---------------------------------------------------------------
    // Get current selected sort
    // ---------------------------------------------------------------

    getPramoghCurrentSortState() {
        const weightDirection =
            window.PramoghWeightController?.getDirection?.();

        if (weightDirection) {
            const state = {
                type: 'weight',
                value: weightDirection
            };
            this.pramoghSortState = state;
            return state;
        }

        const urlState = this.getPramoghSortStateFromURL();
        if (urlState) {
            this.pramoghSortState = urlState;
            return urlState;
        }

        this.pramoghSortState = null;
        return null;
    }

    // ---------------------------------------------------------------
    // Preserve current sort inside any AJAX URL
    // ---------------------------------------------------------------

    preservePramoghSortInURL(
        href
    ) {
        try {
            var targetUrl =
                new URL(
                    href,
                    window.location.origin
                );

            var currentState =
                this.getPramoghCurrentSortState();

            if (!currentState) {
                return (
                    targetUrl.pathname +
                    targetUrl.search +
                    targetUrl.hash
                );
            }

            // -------------------------------------------------------
            // WEIGHT SORT
            // -------------------------------------------------------

            if (
                currentState.type ===
                'weight'
            ) {
                // WEIGHT OWNS THE SORT STATE. Never inject Shopify's
                // native sort_by into the filter URL. Doing that was the
                // exact reason filter URLs became ?sort_by=best-selling.
                // Shopify can use its default/native order for the section
                // HTML; the Pramogh backend owns the actual product order.
                targetUrl.searchParams.delete('sort_by');
                targetUrl.searchParams.set(
                    'pramogh_weight_sort',
                    currentState.value
                );
            }

            // -------------------------------------------------------
            // NATIVE SHOPIFY SORT
            // -------------------------------------------------------

            if (
                currentState.type ===
                'native'
            ) {
                targetUrl.searchParams.delete(
                    'pramogh_weight_sort'
                );

                targetUrl.searchParams.set(
                    'sort_by',
                    currentState.value
                );
            }

            return (
                targetUrl.pathname +
                targetUrl.search +
                targetUrl.hash
            );
        } catch (error) {
            console.error(
                'PRAMOGH SORT URL PRESERVE ERROR:',
                error
            );

            return href;
        }
    }

    // ---------------------------------------------------------------
    // Restore native Shopify sort UI
    // ---------------------------------------------------------------

    restorePramoghNativeSortToolbarState(
        sortValue
    ) {
        if (!sortValue) {
            return;
        }

        var sortingContainers =
            this.querySelectorAll(
                '[data-sorting]'
            );

        if (
            !sortingContainers.length
        ) {
            return;
        }

        var foundButton = null;

        sortingContainers.forEach(
            (
                sortContainer
            ) => {
                if (foundButton) {
                    return;
                }

                var buttons =
                    sortContainer.querySelectorAll(
                        '[data-sort-by-item]'
                    );

                buttons.forEach(
                    (
                        button
                    ) => {
                        if (foundButton) {
                            return;
                        }

                        var textElement =
                            button.querySelector(
                                '.text'
                            );

                        if (!textElement) {
                            return;
                        }

                        var dataValue =
                            textElement.getAttribute(
                                'data-value'
                            );

                        var dataHref =
                            textElement.getAttribute(
                                'data-href'
                            );

                        if (
                            dataValue ===
                                sortValue ||
                            dataHref ===
                                sortValue
                        ) {
                            foundButton =
                                button;
                        }
                    }
                );
            }
        );

        if (!foundButton) {
            console.warn(
                'PRAMOGH SORT UI: Native sort button not found for:',
                sortValue
            );

            return;
        }

        var sortContainer =
            foundButton.closest(
                '[data-sorting]'
            );

        if (!sortContainer) {
            return;
        }

        // -----------------------------------------------------------
        // Remove all active states
        // -----------------------------------------------------------

        this.querySelectorAll(
            '[data-sort-by-item]'
        ).forEach(
            (
                button
            ) => {
                button.classList.remove(
                    'is-active'
                );
            }
        );

        this.querySelectorAll(
            '[data-pramogh-weight-sort]'
        ).forEach(
            (
                button
            ) => {
                button.classList.remove(
                    'is-active'
                );
            }
        );

        // -----------------------------------------------------------
        // Activate correct native sort
        // -----------------------------------------------------------

        foundButton.classList.add(
            'is-active'
        );

        // -----------------------------------------------------------
        // Update toolbar label
        // -----------------------------------------------------------

        var textElement =
            foundButton.querySelector(
                '.text'
            );

        var labelText =
            sortContainer.querySelector(
                '.label-text'
            );

        if (
            textElement &&
            labelText
        ) {
            labelText.innerText =
                textElement.innerText;
        }

        // -----------------------------------------------------------
        // Close dropdown
        // -----------------------------------------------------------

        var toggle =
            sortContainer.querySelector(
                '[data-toggle]'
            );

        if (toggle) {
            toggle.setAttribute(
                'aria-expanded',
                'false'
            );
        }

        if (
            sortContainer.dataset
                .mobile ===
            'mobile'
        ) {
            var mobileToggle =
                this.querySelector(
                    '[data-toggle][data-mobile="mobile"]'
                );

            if (mobileToggle) {
                mobileToggle.setAttribute(
                    'aria-expanded',
                    'false'
                );
            }

            document.body.classList.remove(
                'toolbar-modal-open'
            );
        }
    }

    // ---------------------------------------------------------------
    // Restore current sort UI
    // ---------------------------------------------------------------

    restorePramoghSortToolbarState() {
        var currentState =
            this.getPramoghCurrentSortState();

        if (!currentState) {
            return;
        }

        if (
            currentState.type ===
            'weight'
        ) {
            this.setPramoghWeightToolbarState(
                currentState.value
            );

            // ---------------------------------------------------
            // FIX: on a direct/hard page load with
            // ?pramogh_weight_sort=... already in the URL, the
            // native Shopify pagination is server-rendered and
            // this code path (unlike loadPramoghWeightSort) used
            // to never strip it out — causing two pagination
            // bars to appear. Remove the native one here too.
            // ---------------------------------------------------
            this.removeNativePramoghPagination();

            return;
        }

        if (
            currentState.type ===
            'native'
        ) {
            this.restorePramoghNativeSortToolbarState(
                currentState.value
            );
        }
    }

    // ================================================================
    // CREATE URL HASH
    // ================================================================

    createURLHash(baseLink) {
        var newQuery =
            $.param(
                Shopify.queryParams
            ).replace(
                /%2B/g,
                '+'
            );

        if (baseLink) {
            if (newQuery != '') {
                return (
                    baseLink +
                    '?' +
                    newQuery
                );
            } else {
                return baseLink;
            }
        } else {
            if (newQuery != '') {
                return (
                    location.pathname +
                    '?' +
                    newQuery
                );
            } else {
                return location.pathname;
            }
        }
    }

    // ================================================================
    // UPDATE URL HASH
    // ================================================================

    updateURLHash(baseLink, forcedSortState = null) {
        delete Shopify.queryParams.page;

        // PRAMOGH: Weight sort is a backend-only sort state in the
        // browser URL. Shopify still needs its valid native sort_by
        // for the section/filter request, but it must NOT leak into
        // the visible URL as a second active sort.
        try {
            var currentSortState =
                forcedSortState ||
                this.getPramoghCurrentSortState();

            if (
                currentSortState &&
                currentSortState.type === 'weight'
            ) {
                delete Shopify.queryParams.sort_by;
                Shopify.queryParams.pramogh_weight_sort =
                    currentSortState.value;
            }
        } catch (error) {
            console.warn(
                'PRAMOGH URL SORT CLEANUP ERROR:',
                error
            );
        }

        var newUrl =
            this.createURLHash(
                baseLink
            );

        history.pushState(
            {
                param:
                    Shopify.queryParams
            },
            newUrl,
            newUrl
        );
    }

    // ================================================================
    // CURRENCY
    // ================================================================

    checkNeedToConvertCurrency() {
        var currencyItem =
            $('.dropdown-item[data-currency]');

        if (currencyItem.length) {
            return (
                (window.show_multiple_currencies &&
                    Currency.currentCurrency !=
                        shopCurrency) ||
                window.show_auto_currency
            );
        } else {
            return;
        }
    }

    // ================================================================
    // DROPDOWN
    // ================================================================

    onClickDropdownButtonHandler(
        event
    ) {
        var buttonElement =
            event.currentTarget;

        if (
            buttonElement.dataset
                .mobile ===
            'mobile'
        ) {
            document.body.classList.add(
                'toolbar-modal-open'
            );
        }

        if (
            buttonElement.getAttribute(
                'aria-expanded'
            ) === 'false'
        ) {
            buttonElement.setAttribute(
                'aria-expanded',
                true
            );
        } else {
            buttonElement.setAttribute(
                'aria-expanded',
                false
            );
        }
    }

    // ================================================================
    // NATIVE SHOPIFY SORT
    // ================================================================

    onClickSortByButtonHandler(
        event
    ) {
        event.preventDefault();

        var buttonElement =
            event.currentTarget;

        this.sortBy =
            buttonElement.closest(
                '[data-sorting]'
            );

        if (
            buttonElement.classList.contains(
                'is-active'
            )
        ) {
            return;
        }

        var textElement =
            buttonElement.querySelector(
                '.text'
            );

        if (!textElement) {
            return;
        }

        var value =
            textElement.getAttribute(
                'data-value'
            );

        var href =
            textElement.getAttribute(
                'data-href'
            );

        var text =
            textElement.innerText;

        // ------------------------------------------------------------
        // Some themes may not have data-value.
        // Use data-href as fallback.
        // ------------------------------------------------------------

        if (!value && href) {
            value = href;
        }

        if (!value) {
            return;
        }

        // ============================================================
        // EXPLICIT NATIVE SORT = HAND OWNERSHIP BACK TO SHOPIFY
        // ============================================================
        // This is the only native-sort path that is allowed to clear
        // the independent Weight controller state. Filter/AJAX URLs
        // must never do this implicitly.
        // Explicit native sorting is the only action that releases the
        // Weight filter-removal lock.
        try {
            delete window.__PRAMOGH_FILTER_SORT_LOCK__;
        } catch (error) {}

        if (window.PramoghWeightController) {
            window.PramoghWeightController.clear();
        } else {
            try {
                window.__PRAMOGH_WEIGHT_STATE__ = {
                    pathname: window.location.pathname,
                    active: false,
                    direction: null
                };
            } catch (error) {}
        }

        this.savePramoghSortState(
            'native',
            value
        );

        // ============================================================
        // UPDATE TOOLBAR LABEL
        // ============================================================

        if (
            this.sortBy &&
            this.sortBy.querySelector(
                '.label-text'
            )
        ) {
            this.sortBy.querySelector(
                '.label-text'
            ).innerText = text;
        }

        // ============================================================
        // CLOSE DROPDOWN
        // ============================================================

        if (
            this.sortBy &&
            this.sortBy.querySelector(
                '[data-toggle]'
            )
        ) {
            this.sortBy
                .querySelector(
                    '[data-toggle]'
                )
                ?.setAttribute(
                    'aria-expanded',
                    false
                );
        }

        // ============================================================
        // CLEAR ALL SORT ACTIVE STATES
        // ============================================================

        this.querySelectorAll(
            '[data-sort-by-item]'
        ).forEach(
            (
                sortButton
            ) => {
                sortButton.classList.remove(
                    'is-active'
                );
            }
        );

        this.querySelectorAll(
            '[data-pramogh-weight-sort]'
        ).forEach(
            (
                weightButton
            ) => {
                weightButton.classList.remove(
                    'is-active'
                );
            }
        );

        buttonElement.classList.add(
            'is-active'
        );

        // ============================================================
        // MOBILE
        // ============================================================

        if (
            this.sortBy &&
            this.sortBy.dataset
                .mobile ===
                'mobile'
        ) {
            const dropdownButton =
                this.querySelector(
                    '[data-toggle][data-mobile="mobile"]'
                );

            if (dropdownButton) {
                dropdownButton.setAttribute(
                    'aria-expanded',
                    false
                );
            }

            document.body.classList.remove(
                'toolbar-modal-open'
            );
        }

        // ============================================================
        // UPDATE SHOPIFY QUERY PARAM
        // ============================================================

        Shopify.queryParams.sort_by =
            value;

        delete Shopify.queryParams
            .pramogh_weight_sort;

        delete Shopify.queryParams.page;

        // ============================================================
        // UPDATE URL
        // ============================================================

        // IMPORTANT: force this URL transaction to use the explicitly
        // selected native sort. Do not let getPramoghCurrentSortState()
        // read the old pramogh_weight_sort from the browser URL before
        // history.pushState() has happened.
        this.updateURLHash(
            null,
            {
                type: 'native',
                value: value
            }
        );

        // ============================================================
        // RENDER
        // ============================================================

        this.renderPage(
            location.href
        );
    }

    // ================================================================
    // PRAMOGH WEIGHT SORT — CLICK
    // ================================================================

    onClickPramoghWeightSortHandler(
        event
    ) {
        event.preventDefault();
        event.stopPropagation();

        if (
            event.stopImmediatePropagation
        ) {
            event.stopImmediatePropagation();
        }

        var buttonElement =
            event.currentTarget;

        var direction =
            buttonElement.getAttribute(
                'data-pramogh-weight-sort'
            );

        if (
            direction !== 'asc' &&
            direction !== 'desc'
        ) {
            return;
        }

        // ============================================================
        // SAVE GENERIC WEIGHT SORT STATE
        // ============================================================

        // ============================================================
        // ACTIVATE WEIGHT SORT
        // ============================================================

        this.activatePramoghWeightSort(direction, 1);
    }

    // ================================================================
    // FILTER FORM SORT SYNCHRONIZATION
    // ================================================================
    // Shopify's filter form contains a hidden native sort_by input.
    // Keep that input ACTIVE at all times and synchronize it with the
    // current valid Shopify sort. Our custom Weight sort is carried
    // separately through pramogh_weight_sort.

    setPramoghFilterFormSortState(type, value = null) {
        const form = document.getElementById('CollectionFiltersForm');
        if (!form) return;

        const url = new URL(window.location.href);
        const urlNativeSort = url.searchParams.get('sort_by');
        const existingSortInput = form.querySelector(
            'input[name="sort_by"]'
        );
        const existingNativeSort = existingSortInput?.value || null;

        const nativeSort =
            value ||
            urlNativeSort ||
            existingNativeSort ||
            'best-selling';

        const nativeSortInputs = form.querySelectorAll(
            'input[name="sort_by"]'
        );

        nativeSortInputs.forEach((input) => {
            // NEVER disable/remove Shopify's native sort input.
            input.disabled = false;
            input.dataset.pramoghSortDisabled = 'false';
            input.value = nativeSort;
        });
    }

    // ================================================================
    // SET WEIGHT TOOLBAR STATE
    // ================================================================

    setPramoghWeightToolbarState(
        direction
    ) {
        if (
            direction !== 'asc' &&
            direction !== 'desc'
        ) {
            return;
        }

        // Keep Shopify's valid native sort_by input synchronized.
        // Weight direction is stored separately in pramogh_weight_sort.
        this.setPramoghFilterFormSortState('weight');

        // The topbar select is dynamically replaced by filter AJAX, so
        // always synchronize it from the same canonical weight state.
        this.syncPramoghTopbarSortSelect(direction);

        var weightButton =
            this.querySelector(
                '[data-pramogh-weight-sort="' +
                    direction +
                    '"]'
            );

        if (!weightButton) {
            return;
        }

        var sortByContainer =
            weightButton.closest(
                '[data-sorting]'
            );

        var weightTextElement =
            weightButton.querySelector(
                '.text'
            );

        var weightText =
            weightTextElement
                ? weightTextElement.innerText
                : direction === 'asc'
                ? 'Weight, low to high'
                : 'Weight, high to low';

        if (sortByContainer) {
            var labelText =
                sortByContainer.querySelector(
                    '.label-text'
                );

            if (labelText) {
                labelText.innerText =
                    weightText;
            }

            sortByContainer
                .querySelectorAll(
                    '[data-sort-by-item]'
                )
                .forEach(
                    (
                        sortByButton
                    ) => {
                        sortByButton.classList.remove(
                            'is-active'
                        );
                    }
                );

            sortByContainer
                .querySelectorAll(
                    '[data-pramogh-weight-sort]'
                )
                .forEach(
                    (
                        button
                    ) => {
                        button.classList.remove(
                            'is-active'
                        );
                    }
                );

            weightButton.classList.add(
                'is-active'
            );

            var toggle =
                sortByContainer.querySelector(
                    '[data-toggle]'
                );

            if (toggle) {
                toggle.setAttribute(
                    'aria-expanded',
                    'false'
                );
            }

            if (
                sortByContainer.dataset
                    .mobile ===
                'mobile'
            ) {
                var mobileDropdownButton =
                    this.querySelector(
                        '[data-toggle][data-mobile="mobile"]'
                    );

                if (
                    mobileDropdownButton
                ) {
                    mobileDropdownButton.setAttribute(
                        'aria-expanded',
                        'false'
                    );
                }

                document.body.classList.remove(
                    'toolbar-modal-open'
                );
            }
        }
    }

    // ================================================================
    // RESTORE SORT TOOLBAR STATE
    // ================================================================

    restorePramoghWeightToolbarState() {
        this.pramoghSaveCurrentSortState();

        this.restorePramoghSortToolbarState();
    }

    // ================================================================
    // PRAMOGH WEIGHT SORT — PAGINATION HANDLER
    // ================================================================

    bindPramoghWeightPagination() {
        if (this.pramoghWeightPaginationBound) {
            return;
        }

        this.pramoghWeightPaginationBound = true;

        document.addEventListener(
            'click',
            (event) => {
                const link = event.target.closest(
                    '#CollectionProductGrid .pagination-wrapper a, ' +
                    '#CollectionProductGrid .pagination a'
                );

                if (!link) {
                    return;
                }

                const currentUrl = new URL(window.location.href);
                const direction = currentUrl.searchParams.get(
                    'pramogh_weight_sort'
                );

                if (direction !== 'asc' && direction !== 'desc') {
                    return;
                }

                const href = link.getAttribute('href');

                if (!href || href === '#') {
                    return;
                }

                let paginationUrl;

                try {
                    paginationUrl = new URL(
                        href,
                        window.location.origin
                    );
                } catch (error) {
                    return;
                }

                const page = parseInt(
                    paginationUrl.searchParams.get('page') || '1',
                    10
                );

                if (!Number.isFinite(page) || page < 1) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();

                if (event.stopImmediatePropagation) {
                    event.stopImmediatePropagation();
                }

                this.loadPramoghWeightSort(
                    direction,
                    page,
                    true,
                    paginationUrl.href
                );
            },
            true
        );
    }

    // Kept for compatibility with existing calls.
    // Native Shopify pagination must NOT be removed.
    removeNativePramoghPagination() {
        const customPagination =
            document.getElementById(
                'pramogh-weight-pagination'
            );

        if (customPagination) {
            customPagination.remove();
        }
    }

    // ================================================================
    // PRAMOGH WEIGHT SORT — MAIN LOADER
    // ================================================================

    async loadPramoghWeightSort(
        direction,
        page = 1,
        updateURL = true,
        sourceUrl = null
    ) {
        // Each request gets a token. A newer filter/page/sort request
        // is allowed to supersede an older one instead of being blocked
        // by a stale loading flag.
        var requestId =
            ++this.pramoghWeightRequestId;

        // Cancel the previous backend request immediately. Request IDs
        // already protect the UI from stale responses, but cancellation
        // also prevents old filter requests from continuing to consume
        // Vercel/Shopify resources when several filters are selected quickly.
        if (this.pramoghWeightAbortController) {
            this.pramoghWeightAbortController.abort();
        }

        var abortController =
            new AbortController();

        this.pramoghWeightAbortController =
            abortController;

        this.pramoghWeightLoading =
            true;

        document.body.classList.add(
            'has-halo-loader'
        );

        try {
            var currentPage =
                parseInt(
                    page || '1',
                    10
                );

            if (
                !Number.isFinite(
                    currentPage
                ) ||
                currentPage < 1
            ) {
                currentPage = 1;
            }

            var productsPerPage = 32;

            // ========================================================
            // FILTER KEY
            // ========================================================
            //
            // The URL is the source of truth. Do not cache the entire
            // sorted collection in the browser: the backend now owns
            // filtering, sorting and pagination.

            // When a filter response is async, window.location may have
            // changed again before this request runs. Use the exact URL
            // captured by the filter flow when one was supplied.
            var currentUrl =
                new URL(
                    sourceUrl || window.location.href,
                    window.location.origin
                );

            var filterParams =
                new URLSearchParams();

            // Shopify can represent multiple selections from ANY filter
            // family as repeated query keys. This includes option filters
            // (weight/color/etc.) and metafield filters such as Shape.
            //
            // Keep the browser URL untouched, but send every repeated filter
            // key to the app proxy as ONE comma-separated parameter. This is
            // important when 2+ sub-filters from the same family are selected:
            // the backend receives the complete OR set instead of only one
            // value or a malformed repeated query parameter.
            //
            // Example:
            //   filter.p.m.my_fields.shape=Oval&...shape=Round
            // becomes:
            //   filter.p.m.my_fields.shape=Oval,Round
            //
            // This applies to ANY repeated Shopify filter key, not just
            // filter.v.option.*, so future filter families work automatically.
            var repeatedFilterValues =
                new Map();

            currentUrl.searchParams.forEach(
                (value, key) => {
                    if (
                        key === 'pramogh_weight_sort' ||
                        key === 'page' ||
                        key === 'sort_by'
                    ) {
                        return;
                    }

                    var values =
                        repeatedFilterValues.get(key) || [];

                    values.push(value);
                    repeatedFilterValues.set(key, values);
                }
            );

            repeatedFilterValues.forEach(
                (values, key) => {
                    filterParams.append(
                        key,
                        values.join(',')
                    );
                }
            );

            // ========================================================
            // FETCH ONLY THE REQUESTED PAGE
            // ========================================================

            var pathParts =
                location.pathname.split(
                    '/collections/'
                );

            if (!pathParts[1]) {
                throw new Error(
                    'Collection handle could not be detected.'
                );
            }

            var collectionHandle =
                pathParts[1].split('/')[0];

            // Build the backend URL with URLSearchParams instead of string
            // concatenation. This preserves EVERY repeated filter value
            // (including 3+ values from the same Shopify filter family)
            // without relying on the browser's query-string serialization.
            var apiUrlObject =
                new URL(
                    '/apps/pramogh-weight-sort',
                    window.location.origin
                );

            apiUrlObject.searchParams.set(
                'collection',
                collectionHandle
            );
            apiUrlObject.searchParams.set(
                'direction',
                direction
            );
            apiUrlObject.searchParams.set(
                'page',
                String(currentPage)
            );

            filterParams.forEach(
                (value, key) => {
                    apiUrlObject.searchParams.append(
                        key,
                        value
                    );
                }
            );

            var apiUrl =
                apiUrlObject.pathname +
                apiUrlObject.search;

            console.log(
                'PRAMOGH WEIGHT SORT API:',
                apiUrl
            );

            var response =
                await fetch(
                    apiUrl,
                    {
                        method: 'GET',
                        credentials: 'same-origin',
                        headers: {
                            Accept: 'application/json'
                        },
                        signal: abortController.signal
                    }
                );

            if (!response.ok) {
                throw new Error(
                    'Weight sort backend returned HTTP ' +
                        response.status
                );
            }

            var data =
                await response.json();

            if (
                !data ||
                data.success !== true
            ) {
                throw new Error(
                    (data && data.error) ||
                        'Weight sort backend failed.'
                );
            }

            if (!Array.isArray(data.products)) {
                throw new Error(
                    'Backend did not return products array.'
                );
            }

            var pageProducts =
                data.products;

            productsPerPage =
                Number(data.productsPerPage) ||
                productsPerPage;

            var totalProducts =
                Number(data.totalProducts) || 0;

            var totalPages =
                Number(data.totalPages) ||
                Math.ceil(
                    totalProducts /
                        productsPerPage
                );

            // Backend clamps invalid/out-of-range pages. Use the
            // effective page so pagination + URL never disagree.
            currentPage =
                Number(data.page) || currentPage;

            // A newer request may have started while Shopify was
            // responding. Never let an old response overwrite it.
            if (requestId !== this.pramoghWeightRequestId) {
                return;
            }

            // ========================================================
            // RENDER PRODUCTS
            // ========================================================

            await this.renderPramoghWeightProducts(
                pageProducts
            );

            if (requestId !== this.pramoghWeightRequestId) {
                return;
            }

            // ========================================================
            // PAGINATION
            // ========================================================

            // Backend is the source of truth for the effective page.
            currentPage =
                Number(data.page) || currentPage;

            this.renderPramoghWeightPagination(
                totalProducts,
                currentPage,
                productsPerPage,
                direction
            );

            // ========================================================
            // URL
            // ========================================================

            if (updateURL) {
                var cleanUrl =
                    new URL(
                        window.location.href
                    );

                // Shopify's native sort_by is used by the filter/section
                // request, but it is NOT a second active browser sort.
                // Keep only our custom Weight state in the visible URL.
                cleanUrl.searchParams.delete('sort_by');
                cleanUrl.searchParams.set(
                    'pramogh_weight_sort',
                    direction
                );

                if (
                    currentPage > 1
                ) {
                    cleanUrl.searchParams.set(
                        'page',
                        currentPage
                    );
                } else {
                    cleanUrl.searchParams.delete(
                        'page'
                    );
                }

                history.replaceState(
                    {
                        pramoghWeightSort:
                            direction,
                        page:
                            currentPage
                    },
                    '',
                    cleanUrl.pathname +
                        cleanUrl.search
                );
            }

            // ========================================================
            // KEEP TOOLBAR STATE
            // ========================================================

            this.setPramoghWeightToolbarState(
                direction
            );

            // ========================================================
            // PAGINATION SCROLL
            // ========================================================
            // When the user clicks page 2/3/etc. while already near the
            // bottom of the collection, the grid is replaced in-place.
            // Without resetting scroll, the new page appears from the
            // same bottom-of-page position. Always return to the top of
            // the collection after an actual pagination request.

            if (currentPage > 1) {
                var paginationCollectionGrid =
                    document.getElementById(
                        'CollectionProductGrid'
                    );

                if (paginationCollectionGrid) {
                    var collectionRect =
                        paginationCollectionGrid.getBoundingClientRect();

                    window.scrollTo({
                        top:
                            collectionRect.top +
                            window.pageYOffset -
                            50,
                        behavior:
                            'auto'
                    });
                }
            }

            // ========================================================
            // LAZYLOAD
            // ========================================================

            if (
                typeof lazySizes !==
                    'undefined' &&
                lazySizes.loader
            ) {
                lazySizes.loader.checkElems();
            }
        } catch (error) {
            // An older request is intentionally cancelled when a newer
            // filter/sort request starts. Cancellation is not a failure and
            // must never trigger the user-facing error popup.
            if (error?.name === 'AbortError') {
                return;
            }

            console.error(
                'PRAMOGH WEIGHT SORT ERROR:',
                error
            );

            alert(
                'Weight sorting failed. Please try again.'
            );
        } finally {
            if (requestId === this.pramoghWeightRequestId) {
                this.pramoghWeightLoading = false;
                document.body.classList.remove(
                    'has-halo-loader'
                );

                if (this.pramoghWeightAbortController === abortController) {
                    this.pramoghWeightAbortController = null;
                }
            }
        }
    }

    // ================================================================
    // RENDER PRODUCTS
    // ================================================================

    async renderPramoghWeightProducts(
        pageProducts
    ) {
        var collectionProductGrid =
            document.getElementById(
                'CollectionProductGrid'
            );

        if (!collectionProductGrid) {
            throw new Error(
                'CollectionProductGrid not found.'
            );
        }

        var gridContainer =
            collectionProductGrid.querySelector(
                '.productListing'
            );

        if (!gridContainer) {
            throw new Error(
                'Product listing container not found.'
            );
        }

        // Cancel any older background card rendering.
        var backgroundToken =
            ++this.pramoghWeightBackgroundToken;

        // ============================================================
        // FAST FIRST PAINT
        // ============================================================
        // The old implementation waited for all 32 /products section
        // requests before painting anything. That made the sort feel
        // slow even when the weight API itself was already < 1 second.
        // Render the first 6 cards first (two desktop rows), then fill
        // the remaining cards in small background batches.

        var initialCount = Math.min(
            4,
            pageProducts.length
        );

        var initialProducts =
            pageProducts.slice(
                0,
                initialCount
            );

        var initialCardHtmls =
            await Promise.all(
                initialProducts.map((product) =>
                    this.fetchPramoghWeightCard(product)
                )
            );

        // A newer sort/filter/page request supersedes this render.
        if (
            backgroundToken !==
            this.pramoghWeightBackgroundToken
        ) {
            return;
        }

        var createProductLi = (
            cardHtml,
            product
        ) => {
            if (!cardHtml) {
                return null;
            }

            var li =
                document.createElement(
                    'li'
                );

            li.className =
                'product';

            if (
                product &&
                product.handle
            ) {
                li.setAttribute(
                    'data-product-handle',
                    product.handle
                );
            }

            var temp =
                document.createElement(
                    'div'
                );

            temp.innerHTML =
                cardHtml;

            var wrapper =
                temp.querySelector(
                    '.pramogh-weight-sort-rendered-card'
                );

            if (wrapper) {
                li.innerHTML =
                    wrapper.innerHTML;
            } else {
                li.innerHTML =
                    cardHtml;
            }

            return li;
        };

        var appendCards = (
            cardHtmls,
            products
        ) => {
            var fragment =
                document.createDocumentFragment();

            cardHtmls.forEach(
                (
                    cardHtml,
                    index
                ) => {
                    var li =
                        createProductLi(
                            cardHtml,
                            products[index]
                        );

                    if (li) {
                        fragment.appendChild(
                            li
                        );
                    }
                }
            );

            gridContainer.appendChild(
                fragment
            );
        };

        // Paint first batch immediately.
        gridContainer.innerHTML = '';
        appendCards(
            initialCardHtmls,
            initialProducts
        );

        // ============================================================
        // RESTORE LAYOUT + LIGHTWEIGHT UI HOOKS
        // ============================================================

        var restoreLayout = () => {
            var activeView =
                this.mediaView?.querySelector(
                    '.icon-mode.active'
                );

            if (activeView) {
                var column =
                    parseInt(
                        activeView.dataset.col,
                        10
                    );

                if (
                    Number.isFinite(
                        column
                    )
                ) {
                    this.initViewModeLayout(
                        column
                    );
                }
            }

            if (
                typeof lazySizes !==
                    'undefined' &&
                lazySizes.loader
            ) {
                lazySizes.loader.checkElems();
            }
        };

        restoreLayout();

        // ============================================================
        // BACKGROUND CARD HYDRATION
        // ============================================================
        // Wait briefly so the browser can paint the first products and
        // start above-the-fold image loading before the remaining card
        // requests begin.

        if (
            pageProducts.length > initialCount
        ) {
            setTimeout(
                async () => {
                    if (
                        backgroundToken !==
                        this.pramoghWeightBackgroundToken
                    ) {
                        return;
                    }

                    var batchSize = 20;

                    for (
                        var start = initialCount;
                        start < pageProducts.length;
                        start += batchSize
                    ) {
                        if (
                            backgroundToken !==
                            this.pramoghWeightBackgroundToken
                        ) {
                            return;
                        }

                        var batchProducts =
                            pageProducts.slice(
                                start,
                                start + batchSize
                            );

                        var batchCardHtmls =
                            await Promise.all(
                                batchProducts.map((product) =>
                                    this.fetchPramoghWeightCard(product)
                                )
                            );

                        if (
                            backgroundToken !==
                            this.pramoghWeightBackgroundToken
                        ) {
                            return;
                        }

                        appendCards(
                            batchCardHtmls,
                            batchProducts
                        );

                        restoreLayout();

                        // Yield between batches so card DOM work and
                        // image discovery do not monopolize the main
                        // thread during the initial paint.
                        await new Promise(
                            (resolve) =>
                                setTimeout(
                                    resolve,
                                    0
                                )
                        );
                    }

                    if (
                        backgroundToken !==
                        this.pramoghWeightBackgroundToken
                    ) {
                        return;
                    }

                    if (
                        window.wishlist &&
                        window.wishlist.show
                    ) {
                        this.setLocalStorageProductForWishlist();
                    }

                    if (
                        window.compare &&
                        window.compare.show
                    ) {
                        this.setLocalStorageProductForCompare(
                            {
                                link: $(
                                    '[data-compare-link]'
                                ),
                                onComplete:
                                    null
                            }
                        );
                    }
                },
                300
            );
        } else {
            if (
                window.wishlist &&
                window.wishlist.show
            ) {
                this.setLocalStorageProductForWishlist();
            }

            if (
                window.compare &&
                window.compare.show
            ) {
                this.setLocalStorageProductForCompare(
                    {
                        link: $(
                            '[data-compare-link]'
                        ),
                        onComplete:
                            null
                    }
                );
            }
        }
    }

    // ================================================================
    // FETCH PRODUCT CARD
    // ================================================================

    async fetchPramoghWeightCard(
        product
    ) {
        try {
            var handle =
                product.handle ||
                product.product_handle;

            if (!handle) {
                throw new Error(
                    'Product missing handle: ' +
                        JSON.stringify(
                            product
                        )
                );
            }

            if (this.pramoghWeightCardCache.has(handle)) {
                return this.pramoghWeightCardCache.get(handle);
            }

            // Deduplicate simultaneous requests for the same product.
            if (this.pramoghWeightCardInFlight.has(handle)) {
                return await this.pramoghWeightCardInFlight.get(handle);
            }

            var url =
                '/products/' +
                encodeURIComponent(
                    handle
                ) +
                '?section_id=pramogh-weight-sort-grid';

            var requestPromise =
                fetch(
                    url,
                    {
                        credentials:
                            'same-origin'
                    }
                )
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(
                                'Card fetch failed for ' +
                                    handle +
                                    ': HTTP ' +
                                    response.status
                            );
                        }

                        return response.text();
                    })
                    .then((html) => {
                        var doc =
                            new DOMParser().parseFromString(
                                html,
                                'text/html'
                            );

                        var card =
                            doc.querySelector(
                                '.pramogh-weight-sort-rendered-card'
                            );

                        var cardHtml = card
                            ? card.outerHTML
                            : '';

                        if (cardHtml) {
                            this.pramoghWeightCardCache.set(
                                handle,
                                cardHtml
                            );
                        }

                        return cardHtml;
                    })
                    .finally(() => {
                        this.pramoghWeightCardInFlight.delete(
                            handle
                        );
                    });

            this.pramoghWeightCardInFlight.set(
                handle,
                requestPromise
            );

            return await requestPromise;
        } catch (error) {
            console.error(
                'PRAMOGH WEIGHT SORT CARD ERROR:',
                error
            );

            return '';
        }
    }

    // ================================================================
    // PAGINATION
    // ================================================================

    renderPramoghWeightPagination(
        totalProducts,
        currentPage,
        productsPerPage,
        direction
    ) {
        const collectionProductGrid =
            document.getElementById(
                'CollectionProductGrid'
            );

        if (!collectionProductGrid) {
            return;
        }

        const wrapper =
            collectionProductGrid.querySelector(
                '.pagination-wrapper'
            );

        if (!wrapper) {
            return;
        }

        const nav =
            wrapper.querySelector(
                'nav.pagination, nav.pramogh-pagination'
            );

        if (!nav) {
            return;
        }

        const total = Number(totalProducts || 0);
        const perPage = Number(productsPerPage || 32);
        const page = Number(currentPage || 1);
        const totalPages = Math.ceil(total / perPage);

        const totalElement =
            nav.querySelector(
                '.pagination-page-total, .pramogh-pagination-total'
            );

        if (totalElement) {
            const start =
                total > 0
                    ? (page - 1) * perPage + 1
                    : 0;
            const end = Math.min(page * perPage, total);
            const spans = totalElement.querySelectorAll('span');

            if (spans.length >= 5) {
                spans[1].textContent = start;
                spans[3].textContent = end;
                spans[4].textContent = 'of ' + total + ' total';
            }
        }

        if (totalPages <= 1) {
            wrapper.style.display = 'none';
            return;
        }

        wrapper.style.display = '';

        let list = nav.querySelector('.pagination__list');

        if (!list) {
            list = document.createElement('ul');
            list.className = 'pagination__list list-unstyled';
            list.setAttribute('role', 'list');
            nav.appendChild(list);
        }

        list.innerHTML = '';

        const makeUrl = (targetPage) => {
            const url = new URL(window.location.href);
            // Shopify's native sort stays in the hidden filter input/request;
            // pagination URLs should expose only the custom Weight state.
            url.searchParams.delete('sort_by');
            url.searchParams.set('pramogh_weight_sort', direction);

            if (targetPage > 1) {
                url.searchParams.set('page', targetPage);
            } else {
                url.searchParams.delete('page');
            }

            return url.pathname + url.search;
        };

        const makeItem = (label, targetPage, type, active) => {
            const li = document.createElement('li');
            li.className =
                type === 'arrow'
                    ? 'pagination-arrow'
                    : 'pagination-num';

            if (label === '…') {
                const span = document.createElement('span');
                span.className = 'pagination__item';
                span.textContent = '…';
                li.appendChild(span);
                return li;
            }

            if (active) {
                const span = document.createElement('span');
                span.className =
                    'pagination__item pagination__item--current';
                span.setAttribute('aria-current', 'page');
                span.setAttribute('aria-label', 'Page ' + targetPage);
                span.textContent = label;
                li.appendChild(span);
                return li;
            }

            const a = document.createElement('a');
            a.href = makeUrl(targetPage);
            a.className =
                type === 'arrow'
                    ? 'pagination__item pagination__item--' +
                      (label === 'PREV' ? 'prev' : 'next') +
                      ' pagination__item-arrow link motion-reduce'
                    : 'pagination__item link';
            a.setAttribute(
                'aria-label',
                type === 'arrow' ? label : 'Page ' + targetPage
            );

            if (type === 'arrow') {
                const text = document.createElement('span');
                text.className = 'arrow-text';
                text.textContent = label;
                a.appendChild(text);
            } else {
                a.textContent = label;
            }

            li.appendChild(a);
            return li;
        };

        if (page > 1) {
            list.appendChild(
                makeItem('PREV', page - 1, 'arrow', false)
            );
        }

        const pages = [];

        if (totalPages <= 7) {
            for (let p = 1; p <= totalPages; p++) {
                pages.push(p);
            }
        } else {
            pages.push(1);

            if (page > 4) {
                pages.push('…');
            }

            const startPage = Math.max(2, page - 1);
            const endPage = Math.min(totalPages - 1, page + 1);

            for (let p = startPage; p <= endPage; p++) {
                pages.push(p);
            }

            if (page < totalPages - 3) {
                pages.push('…');
            }

            pages.push(totalPages);
        }

        pages.forEach((pageNumber) => {
            if (pageNumber === '…') {
                list.appendChild(
                    makeItem('…', 0, 'number', false)
                );
                return;
            }

            list.appendChild(
                makeItem(
                    String(pageNumber),
                    pageNumber,
                    'number',
                    pageNumber === page
                )
            );
        });

        if (page < totalPages) {
            list.appendChild(
                makeItem('NEXT', page + 1, 'arrow', false)
            );
        }
    }

    // ================================================================
    // NATIVE SHOPIFY AJAX SECTIONS
    // ================================================================

    getSections() {
        return [
            {
                id:
                    'main-collection-product-grid',
                section:
                    document.getElementById(
                        'main-collection-product-grid'
                    ).dataset.id
            }
        ];
    }

    renderPage(href) {
        // ============================================================
        // CRITICAL:
        //
        // Capture the currently selected Sort By before the filter
        // request starts.
        // ============================================================

        this.pramoghSaveCurrentSortState();

        // ============================================================
        // Force current sort into filter AJAX URL
        // ============================================================

        var preservedHref =
            this.preservePramoghSortInURL(
                href
            );

        console.log(
            'PRAMOGH FILTER SORT PRESERVE:',
            preservedHref
        );

        // ============================================================
        // Synchronize Shopify query params
        // ============================================================

        try {
            var requestUrl =
                new URL(
                    preservedHref,
                    window.location.origin
                );

            var nativeSort =
                requestUrl.searchParams.get(
                    'sort_by'
                );

            var weightSort =
                requestUrl.searchParams.get(
                    'pramogh_weight_sort'
                );

            if (nativeSort) {
                Shopify.queryParams.sort_by =
                    nativeSort;

                delete Shopify.queryParams
                    .pramogh_weight_sort;
            }

            if (weightSort) {
                Shopify.queryParams
                    .pramogh_weight_sort =
                    weightSort;

                delete Shopify.queryParams
                    .sort_by;
            }
        } catch (error) {
            console.warn(
                'PRAMOGH QUERY PARAM SYNC ERROR:',
                error
            );
        }

        // ============================================================
        // Render
        // ============================================================

        const sections =
            this.getSections();

        document.body.classList.add(
            'has-halo-loader'
        );

        sections.forEach(
            (
                section
            ) => {
                this.renderSectionFromFetch(
                    preservedHref,
                    section
                );
            }
        );
    }

    renderSectionFromFetch(
        url,
        section
    ) {
        // ============================================================
        // Make absolutely sure sort survives the request
        // ============================================================

        var preservedUrl =
            this.preservePramoghSortInURL(
                url
            );

        fetch(
            preservedUrl
        )
            .then(
                (
                    response
                ) =>
                    response.text()
            )
            .then(
                (
                    responseText
                ) => {
                    const html =
                        responseText;

                    this.renderSidebar(
                        html
                    );

                    this.renderProductGrid(
                        html,
                        preservedUrl
                    );
                }
            )
            .catch(
                (
                    error
                ) => {
                    console.error(
                        'Native collection render error:',
                        error
                    );

                    document.body.classList.remove(
                        'has-halo-loader'
                    );
                }
            );
    }

    renderSidebar(html) {
        if (
            document.getElementById(
                'main-collection-filters'
            )
        ) {
            const parsed =
                new DOMParser().parseFromString(
                    html,
                    'text/html'
                );

            const newSidebar =
                parsed.getElementById(
                    'main-collection-filters'
                );

            if (newSidebar) {
                document.getElementById(
                    'main-collection-filters'
                ).innerHTML =
                    newSidebar.innerHTML;
            }
        }
    }

    // ================================================================
    // NATIVE PRODUCT GRID RENDER
    // ================================================================

    renderProductGrid(html, requestUrl = window.location.href) {
        // ============================================================
        // CAPTURE SORT STATE BEFORE DOM REPLACEMENT
        // ============================================================

        var currentSortState =
            this.getPramoghCurrentSortState();

        if (!currentSortState) {
            currentSortState =
                this.getPramoghSortStateFromURL();
        }

        // ============================================================
        // Capture current page
        // ============================================================

        var requestParams =
            new URL(
                requestUrl,
                window.location.origin
            ).searchParams;

        var currentPage =
            parseInt(
                requestParams.get(
                    'page'
                ) || '1',
                10
            );

        if (
            !Number.isFinite(
                currentPage
            ) ||
            currentPage < 1
        ) {
            currentPage = 1;
        }

        // ============================================================
        // If URL lost sort but saved state knows it,
        // restore it in browser URL.
        // ============================================================

        if (
            currentSortState &&
            currentSortState.value
        ) {
            var currentBrowserUrl =
                new URL(
                    window.location.href
                );

            if (
                currentSortState.type ===
                'native'
            ) {
                currentBrowserUrl.searchParams.delete(
                    'pramogh_weight_sort'
                );

                currentBrowserUrl.searchParams.set(
                    'sort_by',
                    currentSortState.value
                );
            }

            if (
                currentSortState.type ===
                'weight'
            ) {
                currentBrowserUrl.searchParams.delete(
                    'sort_by'
                );

                currentBrowserUrl.searchParams.set(
                    'pramogh_weight_sort',
                    currentSortState.value
                );
            }

            if (
                currentPage > 1
            ) {
                currentBrowserUrl.searchParams.set(
                    'page',
                    currentPage
                );
            }

            history.replaceState(
                {
                    pramoghSort:
                        currentSortState
                },
                '',
                currentBrowserUrl.pathname +
                    currentBrowserUrl.search
            );
        }

        // ============================================================
        // PARSE NEW HTML
        // ============================================================

        const parsed =
            new DOMParser().parseFromString(
                html,
                'text/html'
            );

        const newCollection =
            parsed
                .getElementById(
                    'CollectionProductGrid'
                )
                ?.querySelector(
                    '.collection'
                );

        const currentCollection =
            document
                .getElementById(
                    'CollectionProductGrid'
                )
                ?.querySelector(
                    '.collection'
                );

        if (
            !newCollection ||
            !currentCollection
        ) {
            console.error(
                'Native collection grid could not be found.'
            );

            document.body.classList.remove(
                'has-halo-loader'
            );

            return;
        }

        // ============================================================
        // WEIGHT SORT: DO NOT LET NATIVE FILTER HTML REPLACE THE
        // PRODUCT GRID. The native response is only used to refresh
        // the sidebar/filter UI. Weight sorting owns the product grid.
        // ============================================================

        if (
            currentSortState &&
            currentSortState.type === 'weight'
        ) {
            var weightDirection =
                currentSortState.value;

            var weightUrl =
                new URL(
                    requestUrl,
                    window.location.origin
                );

            // Preserve Shopify's valid native sort_by and add our
            // custom backend sort direction separately.
            if (!weightUrl.searchParams.get('sort_by')) {
                const sortInput =
                    document.querySelector(
                        '#CollectionFiltersForm input[name="sort_by"]'
                    );
                weightUrl.searchParams.set(
                    'sort_by',
                    sortInput?.value || 'best-selling'
                );
            }
            weightUrl.searchParams.set(
                'pramogh_weight_sort',
                weightDirection
            );

            // Filters changed: always restart at page 1.
            weightUrl.searchParams.delete('page');

            // requestUrl/weightUrl may contain Shopify's native sort_by
            // because that is required for the Shopify section request.
            // Do not expose it as a second active sort in the browser URL.
            weightUrl.searchParams.delete('sort_by');

            history.replaceState(
                {
                    pramoghWeightSort: weightDirection,
                    page: 1
                },
                '',
                weightUrl.pathname +
                    weightUrl.search
            );

            Shopify.queryParams =
                Shopify.queryParams || {};
            Shopify.queryParams.pramogh_weight_sort =
                weightDirection;
            if (!Shopify.queryParams.sort_by) {
                const sortInput =
                    document.querySelector(
                        '#CollectionFiltersForm input[name="sort_by"]'
                    );
                Shopify.queryParams.sort_by =
                    sortInput?.value || 'best-selling';
            }
            delete Shopify.queryParams.page;

            // Remove only the old custom weight pagination.
            // It will be rebuilt from the filtered result count.
            var oldWeightPagination = document.getElementById(
                'pramogh-weight-pagination'
            );
            if (oldWeightPagination) {
                oldWeightPagination.remove();
            }

            // Refresh toolbar references after the sidebar HTML swap.
            this.mediaView =
                this.querySelector('[data-view-as]');
            this.mediaViewMobile =
                this.querySelector('[data-view-as-mobile]');

            if (this.querySelector('[data-sorting]')) {
                this.bindSortingEvents();
            }

            this.setActiveViewModeMediaQuery(true);
            this.setPramoghWeightToolbarState(
                weightDirection
            );

            // Re-run weight sort using the NEW filter URL.
            this.loadPramoghWeightSort(
                weightDirection,
                1,
                false,
                weightUrl.toString()
            );

            return;
        }

        // ============================================================
        // NATIVE SORT: replace collection HTML normally.
        // ============================================================

        currentCollection.innerHTML =
            newCollection.innerHTML;

        // ============================================================
        // REMOVE OLD WEIGHT PAGINATION
        // ============================================================

        var existingPagination =
            document.getElementById(
                'pramogh-weight-pagination'
            );

        if (
            existingPagination
        ) {
            existingPagination.remove();
        }

        // ============================================================
        // CLEAR WEIGHT CACHE
        //
        // Filters changed, therefore weight results need to be
        // fetched again using the new filter state.
        // ============================================================

        this.pramoghWeightProductsCache =
            null;

        this.pramoghWeightDirection =
            null;

        this.pramoghWeightFilterKey =
            null;

        // ============================================================
        // REFRESH TOOLBAR REFERENCES
        // ============================================================

        this.mediaView =
            this.querySelector(
                '[data-view-as]'
            );

        this.mediaViewMobile =
            this.querySelector(
                '[data-view-as-mobile]'
            );

        // ============================================================
        // RESTORE VIEW MODE
        // ============================================================

        this.setActiveViewModeMediaQuery(
            true
        );

        // ============================================================
        // RE-BIND SORTING EVENTS
        // ============================================================

        if (
            this.querySelector(
                '[data-sorting]'
            )
        ) {
            this.bindSortingEvents();
        }

        // ============================================================
        // CRITICAL SORT RESTORATION
        // ============================================================

        if (
    currentSortState &&
    currentSortState.type ===
        'weight'
) {
    // ============================================================
    // RESTORE WEIGHT SORT AFTER FILTER
    // ============================================================

    var restoredWeightDirection =
        currentSortState.value;

    // Save it again so the next filter also knows
    // which weight direction is selected.
    this.savePramoghSortState(
        'weight',
        restoredWeightDirection
    );

    // Restore toolbar UI immediately.
    this.setPramoghWeightToolbarState(
        restoredWeightDirection
    );

    // ============================================================
    // IMPORTANT:
    // Keep pramogh_weight_sort in the CURRENT browser URL
    // after filter replacement.
    // ============================================================

    var restoredUrl =
        new URL(
            window.location.href
        );

    // Keep only the custom Weight state in the browser URL.
    // Shopify's native sort remains alive in the hidden filter input and
    // is added to the Shopify section request separately.
    restoredUrl.searchParams.delete('sort_by');
    restoredUrl.searchParams.set(
        'pramogh_weight_sort',
        restoredWeightDirection
    );

    if (
        currentPage > 1
    ) {
        restoredUrl.searchParams.set(
            'page',
            currentPage
        );
    } else {
        restoredUrl.searchParams.delete(
            'page'
        );
    }

    history.replaceState(
        {
            pramoghSort:
                currentSortState
        },
        '',
        restoredUrl.pathname +
            restoredUrl.search
    );

    // Update Shopify query params too.
    Shopify.queryParams =
        Shopify.queryParams || {};

    Shopify.queryParams
        .pramogh_weight_sort =
        restoredWeightDirection;

    // Keep Shopify's native sort_by. The backend simply ignores it
    // when constructing the weight-sort request.
    if (!Shopify.queryParams.sort_by) {
        const restoredSortInput =
            document.querySelector(
                '#CollectionFiltersForm input[name="sort_by"]'
            );
        Shopify.queryParams.sort_by =
            restoredSortInput?.value || 'best-selling';
    }

    // ============================================================
    // NOW RUN CUSTOM WEIGHT SORT ON FILTERED PRODUCTS
    // ============================================================

    this.loadPramoghWeightSort(
        restoredWeightDirection,
        currentPage,
        false
    );

    return;
}

        if (
            currentSortState &&
            currentSortState.type ===
                'native'
        ) {
            // --------------------------------------------------------
            // NATIVE SHOPIFY SORT
            //
            // Shopify already returned products in correct order.
            // We only restore the UI.
            // --------------------------------------------------------

            this.restorePramoghNativeSortToolbarState(
                currentSortState.value
            );
        }

        // ============================================================
        // COMPARE
        // ============================================================

        if (
            window.compare &&
            window.compare.show
        ) {
            this.setLocalStorageProductForCompare(
                {
                    link: $(
                        '[data-compare-link]'
                    ),
                    onComplete:
                        null
                }
            );
        }

        // ============================================================
        // WISHLIST
        // ============================================================

        if (
            window.wishlist &&
            window.wishlist.show
        ) {
            this.setLocalStorageProductForWishlist();
        }

        // ============================================================
        // MOBILE SCROLL
        // ============================================================

        if (
            window.innerWidth <
            1025
        ) {
            var collectionGrid =
                document.getElementById(
                    'CollectionProductGrid'
                );

            if (collectionGrid) {
                window.scrollTo({
                    top:
                        collectionGrid.getBoundingClientRect()
                            .top +
                        window.pageYOffset -
                        50,
                    behavior:
                        'smooth'
                });
            }
        }

        // ============================================================
        // LAZYLOAD
        // ============================================================

        if (
            typeof lazySizes !==
                'undefined' &&
            lazySizes.loader
        ) {
            lazySizes.loader.checkElems();
        }

        // ============================================================
        // STOP LOADER
        // ============================================================

        document.body.classList.remove(
            'has-halo-loader'
        );
    }

    // ================================================================
    // COMPARE
    // ================================================================

    setLocalStorageProductForCompare(
        $link
    ) {
        var count =
                JSON.parse(
                    localStorage.getItem(
                        'compareItem'
                    )
                ),
            items = $(
                '[data-product-compare-handle]'
            );

        if (
            count !== null
        ) {
            if (
                items.length > 0
            ) {
                items.each(
                    (
                        index,
                        element
                    ) => {
                        var item = $(
                                element
                            ),
                            handle =
                                item.data(
                                    'product-compare-handle'
                                );

                        if (
                            count.indexOf(
                                handle
                            ) >= 0
                        ) {
                            item.find(
                                '.compare-icon'
                            ).addClass(
                                'is-checked'
                            );

                            item.find(
                                '.text'
                            ).text(
                                window
                                    .compare
                                    .added
                            );

                            item.find(
                                'input'
                            ).prop(
                                'checked',
                                true
                            );
                        } else {
                            item.find(
                                '.compare-icon'
                            ).removeClass(
                                'is-checked'
                            );

                            item.find(
                                '.text'
                            ).text(
                                window
                                    .compare
                                    .add
                            );

                            item.find(
                                'input'
                            ).prop(
                                'checked',
                                false
                            );
                        }
                    }
                );
            }
        }
    }

    // ================================================================
    // WISHLIST
    // ================================================================

    setLocalStorageProductForWishlist() {
        var wishlistList =
            localStorage.getItem(
                'wishlistItem'
            )
                ? JSON.parse(
                      localStorage.getItem(
                          'wishlistItem'
                      )
                  )
                : [];

        localStorage.setItem(
            'wishlistItem',
            JSON.stringify(
                wishlistList
            )
        );

        if (
            wishlistList.length >
            0
        ) {
            wishlistList =
                JSON.parse(
                    localStorage.getItem(
                        'wishlistItem'
                    )
                );

            wishlistList.forEach(
                (
                    handle
                ) => {
                    this.setProductForWishlist(
                        handle
                    );
                }
            );
        }

        $('[data-wishlist-count]').text(
            wishlistList.length
        );
    }

    setProductForWishlist(
        handle
    ) {
        var wishlistList =
                JSON.parse(
                    localStorage.getItem(
                        'wishlistItem'
                    )
                ),
            item = $(
                '[data-wishlist-handle="' +
                    handle +
                    '"]'
            ),
            index =
                wishlistList.indexOf(
                    handle
                );

        if (
            index >= 0
        ) {
            item
                .addClass(
                    'wishlist-added'
                )
                .find('.text')
                .text(
                    window.wishlist
                        .added
                );
        } else {
            item
                .removeClass(
                    'wishlist-added'
                )
                .find('.text')
                .text(
                    window.wishlist
                        .add
                );
        }
    }

    // ================================================================
    // VIEW MODE
    // ================================================================

    setActiveViewModeMediaQuery(
        ajaxLoading = true
    ) {
        var viewMode =
                this.mediaView?.querySelector(
                    '.icon-mode.active'
                ),
            viewModeMobile =
                this.mediaViewMobile?.querySelector(
                    '.icon-mode.active'
                ),
            column =
                parseInt(
                    viewMode?.dataset.col
                ),
            windowWidth =
                window.innerWidth;

        if (
            column != 1
        ) {
            if (
                document.querySelector(
                    '.sidebar--layout_vertical'
                )
            ) {
                if (
                    windowWidth <
                    768
                ) {
                    if (
                        column == 3 ||
                        column == 4 ||
                        column == 5
                    ) {
                        column = 2;

                        viewMode?.classList.remove(
                            'active'
                        );

                        viewModeMobile?.classList.remove(
                            'active'
                        );

                        this.mediaView
                            ?.querySelector(
                                '.grid-2'
                            )
                            ?.classList.add(
                                'active'
                            );

                        this.mediaViewMobile
                            ?.querySelector(
                                '.grid-2'
                            )
                            ?.classList.add(
                                'active'
                            );
                    }
                } else if (
                    windowWidth <=
                        1100 &&
                    windowWidth >=
                        768
                ) {
                    if (
                        column == 5 ||
                        column == 4 ||
                        column == 3
                    ) {
                        column = 2;

                        viewMode?.classList.remove(
                            'active'
                        );

                        viewModeMobile?.classList.remove(
                            'active'
                        );

                        this.mediaView
                            ?.querySelector(
                                '.grid-2'
                            )
                            ?.classList.add(
                                'active'
                            );

                        this.mediaViewMobile
                            ?.querySelector(
                                '.grid-2'
                            )
                            ?.classList.add(
                                'active'
                            );
                    }
                } else if (
                    windowWidth <
                        1299 &&
                    windowWidth >
                        1100
                ) {
                    if (
                        column == 5 ||
                        column == 4
                    ) {
                        column = 3;

                        viewMode?.classList.remove(
                            'active'
                        );

                        viewModeMobile?.classList.remove(
                            'active'
                        );

                        this.mediaView
                            ?.querySelector(
                                '.grid-3'
                            )
                            ?.classList.add(
                                'active'
                            );

                        this.mediaViewMobile
                            ?.querySelector(
                                '.grid-3'
                            )
                            ?.classList.add(
                                'active'
                            );
                    }
                } else if (
                    windowWidth <
                        1700 &&
                    windowWidth >=
                        1299
                ) {
                    if (
                        column == 5
                    ) {
                        column = 4;

                        viewMode?.classList.remove(
                            'active'
                        );

                        viewModeMobile?.classList.remove(
                            'active'
                        );

                        this.mediaView
                            ?.querySelector(
                                '.grid-4'
                            )
                            ?.classList.add(
                                'active'
                            );

                        this.mediaViewMobile
                            ?.querySelector(
                                '.grid-4'
                            )
                            ?.classList.add(
                                'active'
                            );
                    }
                }
            } else {
                if (
                    windowWidth <
                    768
                ) {
                    if (
                        column == 3 ||
                        column == 4 ||
                        column == 5
                    ) {
                        column = 2;

                        viewMode?.classList.remove(
                            'active'
                        );

                        viewModeMobile?.classList.remove(
                            'active'
                        );

                        this.mediaView
                            ?.querySelector(
                                '.grid-2'
                            )
                            ?.classList.add(
                                'active'
                            );

                        this.mediaViewMobile
                            ?.querySelector(
                                '.grid-2'
                            )
                            ?.classList.add(
                                'active'
                            );
                    }
                } else if (
                    windowWidth <
                        992 &&
                    windowWidth >=
                        768
                ) {
                    if (
                        column == 4 ||
                        column == 5
                    ) {
                        column = 3;

                        viewMode?.classList.remove(
                            'active'
                        );

                        viewModeMobile?.classList.remove(
                            'active'
                        );

                        this.mediaView
                            ?.querySelector(
                                '.grid-3'
                            )
                            ?.classList.add(
                                'active'
                            );

                        this.mediaViewMobile
                            ?.querySelector(
                                '.grid-3'
                            )
                            ?.classList.add(
                                'active'
                            );
                    }
                } else if (
                    windowWidth <
                        1600 &&
                    windowWidth >=
                        992
                ) {
                    if (
                        column == 5
                    ) {
                        column = 4;

                        viewMode?.classList.remove(
                            'active'
                        );

                        viewModeMobile?.classList.remove(
                            'active'
                        );

                        this.mediaView
                            ?.querySelector(
                                '.grid-4'
                            )
                            ?.classList.add(
                                'active'
                            );

                        this.mediaViewMobile
                            ?.querySelector(
                                '.grid-4'
                            )
                            ?.classList.add(
                                'active'
                            );
                    }
                }
            }

            this.initViewModeLayout(
                column
            );
        } else {
            if (
                ajaxLoading
            ) {
                this.initViewModeLayout(
                    column
                );
            }
        }
    }

    // ================================================================
    // BANNER POSITIONS
    // ================================================================

    changeBannerPositions(
        column
    ) {
        const collectionProductGrid =
            document.getElementById(
                'main-collection-product-grid'
            );

        if (
            !collectionProductGrid
        ) {
            return;
        }

        const productLists = [
            ...collectionProductGrid.querySelectorAll(
                '.product'
            )
        ];

        const banner1 =
            productLists.find(
                (
                    product
                ) =>
                    product.dataset
                        .productBanner ==
                    1
            );

        const banner2 =
            productLists.find(
                (
                    product
                ) =>
                    product.dataset
                        .productBanner ==
                    2
            );

        const banner3 =
            productLists.find(
                (
                    product
                ) =>
                    product.dataset
                        .productBanner ==
                    3
            );

        if (
            !banner1 ||
            !banner2 ||
            !banner3
        ) {
            return;
        }

        const bannerLists = [
            banner1,
            banner2,
            banner3
        ];

        const getCurrentPosition =
            (
                banner
            ) => {
                const currentIndex =
                    productLists.indexOf(
                        banner
                    );

                return {
                    bannerNumber:
                        banner.dataset
                            .productBanner,
                    currentIndex,
                    originalIndex:
                        parseInt(
                            banner.dataset
                                .firstPosition
                        )
                };
            };

        const getNextPosition =
            (
                info
            ) => {
                let nextPosition =
                    info.currentIndex;

                switch (
                    column
                ) {
                    case 2: {
                        if (
                            info.bannerNumber ==
                            1
                        ) {
                            nextPosition =
                                2;
                        } else if (
                            info.bannerNumber ==
                            2
                        ) {
                            nextPosition =
                                5;
                        } else if (
                            info.bannerNumber ==
                            3
                        ) {
                            nextPosition =
                                8;
                        }

                        collectionProductGrid.classList.add(
                            'banner-full-width'
                        );

                        break;
                    }

                    case 3: {
                        if (
                            info.bannerNumber ==
                            3
                        ) {
                            nextPosition =
                                info.originalIndex;
                        } else {
                            nextPosition =
                                info.originalIndex -
                                1;
                        }

                        break;
                    }

                    case 4: {
                        nextPosition =
                            info.originalIndex;

                        break;
                    }

                    case 5: {
                        if (
                            info.bannerNumber ==
                            3
                        ) {
                            nextPosition =
                                info.originalIndex +
                                3;
                        } else {
                            nextPosition =
                                info.originalIndex +
                                1;
                        }

                        break;
                    }

                    default: {
                        collectionProductGrid.classList.remove(
                            'banner-full-width'
                        );
                    }
                }

                return {
                    bannerNumber:
                        info.bannerNumber,
                    originalIndex:
                        info.originalIndex,
                    currentIndex:
                        nextPosition
                };
            };

        const clearBanner =
            () => {
                if (
                    banner1.parentNode ===
                    collectionProductGrid
                ) {
                    collectionProductGrid.removeChild(
                        banner1
                    );
                }

                if (
                    banner2.parentNode ===
                    collectionProductGrid
                ) {
                    collectionProductGrid.removeChild(
                        banner2
                    );
                }

                if (
                    banner3.parentNode ===
                    collectionProductGrid
                ) {
                    collectionProductGrid.removeChild(
                        banner3
                    );
                }
            };

        const setBannerPosition =
            (
                nextInfo
            ) => {
                const clearedList = [
                    ...collectionProductGrid.querySelectorAll(
                        '.product'
                    )
                ];

                let productBefore =
                    clearedList[
                        nextInfo.currentIndex
                    ];

                const bannerToAppend =
                    bannerLists.find(
                        (
                            banner
                        ) =>
                            banner.dataset
                                .productBanner ==
                            nextInfo.bannerNumber
                    );

                if (
                    bannerToAppend
                ) {
                    collectionProductGrid.insertBefore(
                        bannerToAppend,
                        productBefore
                    );
                }
            };

        const bannersInfo =
            bannerLists.map(
                getCurrentPosition
            );

        const bannersNextInfo =
            bannersInfo.map(
                getNextPosition
            );

        clearBanner();

        bannersNextInfo.forEach(
            setBannerPosition
        );
    }

    // ================================================================
    // GRID LAYOUT
    // ================================================================

    initViewModeLayout(
        column
    ) {
        const productListing =
            document
                .getElementById(
                    'CollectionProductGrid'
                )
                ?.querySelector(
                    '.productListing'
                );

        if (
            !productListing
        ) {
            return;
        }

        switch (
            column
        ) {
            case 1:
                productListing.classList.remove(
                    'productGrid',
                    'column-5',
                    'column-4',
                    'column-3',
                    'column-2'
                );

                productListing.classList.add(
                    'productList'
                );

                break;

            default:
                switch (
                    column
                ) {
                    case 2:
                        productListing.classList.remove(
                            'productList',
                            'column-5',
                            'column-4',
                            'column-3'
                        );

                        productListing.classList.add(
                            'productGrid',
                            'column-2'
                        );

                        break;

                    case 3:
                        productListing.classList.remove(
                            'productList',
                            'column-5',
                            'column-4',
                            'column-2'
                        );

                        productListing.classList.add(
                            'productGrid',
                            'column-3'
                        );

                        break;

                    case 4:
                        productListing.classList.remove(
                            'productList',
                            'column-5',
                            'column-3',
                            'column-2'
                        );

                        productListing.classList.add(
                            'productGrid',
                            'column-4'
                        );

                        break;

                    case 5:
                        productListing.classList.remove(
                            'productList',
                            'column-4',
                            'column-3',
                            'column-2'
                        );

                        productListing.classList.add(
                            'productGrid',
                            'column-5'
                        );

                        break;
                }
        }

        if (
            document.querySelector(
                '.collection-masonry'
            )
        ) {
            resizeAllGridItems();
        }

        if (
            document.querySelector(
                '.collection-banner-adv'
            )
        ) {
            this.changeBannerPositions(
                column
            );
        }
    }

    // ================================================================
    // DESKTOP VIEW MODE
    // ================================================================

    onClickModeButtonHandler(
        event
    ) {
        event.preventDefault();

        var buttonElement =
                event.currentTarget,
            viewMode =
                this.mediaView.querySelector(
                    '.icon-mode.active'
                ),
            column =
                parseInt(
                    buttonElement.dataset.col
                );

        if (
            !buttonElement.classList.contains(
                'active'
            )
        ) {
            viewMode?.classList.remove(
                'active'
            );

            buttonElement.classList.add(
                'active'
            );

            if (
                this.mediaViewMobile
            ) {
                this.mediaViewMobile
                    .querySelectorAll(
                        '.icon-mode'
                    )
                    .forEach(
                        (
                            element
                        ) => {
                            var currentColum =
                                parseInt(
                                    element
                                        .dataset
                                        .col
                                );

                            if (
                                currentColum ==
                                column
                            ) {
                                element.classList.add(
                                    'active'
                                );
                            } else {
                                element.classList.remove(
                                    'active'
                                );
                            }
                        }
                    );
            }

            this.initViewModeLayout(
                column
            );
        }
    }

    // ================================================================
    // MOBILE VIEW MODE
    // ================================================================

    onClickModeButtonMobileHandler(
        event
    ) {
        event.preventDefault();

        var buttonElement =
                event.currentTarget,
            viewMode =
                this.mediaViewMobile.querySelector(
                    '.icon-mode.active'
                ),
            column =
                parseInt(
                    buttonElement.dataset.col
                );

        if (
            !buttonElement.classList.contains(
                'active'
            )
        ) {
            viewMode?.classList.remove(
                'active'
            );

            buttonElement.classList.add(
                'active'
            );

            if (
                this.mediaView
            ) {
                this.mediaView
                    .querySelectorAll(
                        '.icon-mode'
                    )
                    .forEach(
                        (
                            element
                        ) => {
                            var currentColum =
                                parseInt(
                                    element
                                        .dataset
                                        .col
                                );

                            if (
                                currentColum ==
                                column
                            ) {
                                element.classList.add(
                                    'active'
                                );
                            } else {
                                element.classList.remove(
                                    'active'
                                );
                            }
                        }
                    );
            }

            this.initViewModeLayout(
                column
            );
        }
    }

    // ================================================================
    // PRODUCTS PER PAGE
    // ================================================================

    onClickLimitButtonHandler(
        event
    ) {
        event.preventDefault();

        var buttonElement =
            event.currentTarget;

        if (
            !buttonElement.classList.contains(
                'is-active'
            )
        ) {
            var value =
                parseInt(
                    buttonElement
                        .querySelector(
                            '.text'
                        )
                        .dataset.value
                );

            this.limitView
                .querySelector(
                    '.label-text'
                )
                .innerText =
                value;

            this.limitView
                .querySelector(
                    '[data-toggle]'
                )
                .setAttribute(
                    'aria-expanded',
                    false
                );

            this.limitView
                .querySelectorAll(
                    '[data-limited-view-item]'
                )
                .forEach(
                    (
                        limitButton
                    ) => {
                        limitButton.classList.remove(
                            'is-active'
                        );
                    }
                );

            buttonElement.classList.add(
                'is-active'
            );

            $.ajax({
                type: 'POST',
                url: '/cart.js',
                dataType:
                    'json',
                data: {
                    'attributes[pagination]':
                        value
                },

                success:
                    function (
                        data
                    ) {
                        window.location.reload();
                    },

                error:
                    function (
                        xhr,
                        text
                    ) {
                        alert(
                            $.parseJSON(
                                xhr.responseText
                            ).description
                        );
                    }
            });
        }
    }

    // ================================================================
    // CONNECTED CALLBACK
    // ================================================================

    connectedCallback() {
        this.onScrollHandler =
            this.onScroll.bind(
                this
            );

        window.addEventListener(
            'scroll',
            this.onScrollHandler,
            false
        );
    }

    disconnectedCallback() {
        window.removeEventListener(
            'scroll',
            this.onScrollHandler
        );
    }

    // ================================================================
    // SCROLL / STICKY TOOLBAR
    // ================================================================

        onScroll() {
        // Sticky toolbar logic only applies below 1025px.
        // On desktop skip all DOM / layout work.
        if (window.innerWidth >= 1025) {
            return;
        }

        const scrollTop =
            window.pageYOffset ||
            document.documentElement
                .scrollTop;

        const productListing =
            $(
                '#CollectionProductGrid .productListing'
            );

        if (
            !productListing.length
        ) {
            return;
        }

        const offsetScroll =
            productListing.offset()
                .top + 100;

        if (
            scrollTop >
            offsetScroll
        ) {
            requestAnimationFrame(
                this.showSticky.bind(
                    this
                )
            );

            var headerNavigation =
                document.querySelector(
                    '.section-header-navigation'
                );

            var mobileHeader =
                document.querySelector(
                    '.header-mobile'
                );

            var hiddenMobileHeader =
                document.querySelector(
                    '.section-header-mobile'
                );

            if (
                headerNavigation &&
                headerNavigation.classList.contains(
                    'shopify-section-header-show'
                )
            ) {
                if (
                    mobileHeader
                ) {
                    var height =
                        mobileHeader.offsetHeight;

                    this.style.top =
                        `${height}px`;
                }
            } else if (
                hiddenMobileHeader &&
                hiddenMobileHeader.classList.contains(
                    'shopify-section-header-hidden'
                )
            ) {
                this.style.top =
                    0;
            }
        } else {
            requestAnimationFrame(
                this.hideSticky.bind(
                    this
                )
            );
        }

        this.currentScrollTop =
            scrollTop;
    }

    hideSticky() {
        this.classList.remove(
            'show-sticky',
            'animate'
        );

        this.closeDropdownPopupSticky();
    }

    showSticky() {
        this.classList.add(
            'show-sticky',
            'animate'
        );

        this.closeDropdownPopupSticky();
    }

    // ================================================================
    // MOBILE MODAL
    // ================================================================

    closeModalClick() {
        this.closeMobileModal =
            this.querySelector(
                '[data-sorting][data-mobile] .close-mobile-modal'
            );

        if (
            !this.closeMobileModal
        ) {
            return;
        }

        this.closeMobileModal.addEventListener(
            'click',
            () => {
                const dropdownButton =
                    this.querySelector(
                        '[data-toggle][data-mobile="mobile"]'
                    );

                if (
                    dropdownButton
                ) {
                    dropdownButton.setAttribute(
                        'aria-expanded',
                        false
                    );
                }

                document.body.classList.remove(
                    'toolbar-modal-open'
                );
            }
        );
    }

    // ================================================================
    // CLOSE STICKY DROPDOWN
    // ================================================================

    closeDropdownPopupSticky() {
        if (
            this.querySelector(
                '.label-tab'
            )
        ) {
            this.querySelectorAll(
                '.label-tab'
            ).forEach(
                (
                    element
                ) => {
                    element.setAttribute(
                        'aria-expanded',
                        false
                    );
                }
            );
        }
    }

    // ================================================================
    // BODY CLICK
    // ================================================================

    onBodyClickEvent(
        event
    ) {
        if (
            this.querySelector(
                '[data-toggle]'
            )
        ) {
            this.querySelectorAll(
                '[data-toggle]'
            ).forEach(
                (
                    dropdownButton
                ) => {
                    if (
                        dropdownButton
                            .dataset
                            .mobile ===
                        'mobile'
                    ) {
                        const contentDropdown =
                            this.querySelector(
                                '[data-sorting][data-mobile]'
                            );

                        if (
                            contentDropdown &&
                            !contentDropdown.contains(
                                event.target
                            ) &&
                            !dropdownButton.contains(
                                event.target
                            )
                        ) {
                            dropdownButton.setAttribute(
                                'aria-expanded',
                                false
                            );

                            if (
                                document.body.classList.contains(
                                    'toolbar-modal-open'
                                )
                            ) {
                                document.body.classList.remove(
                                    'toolbar-modal-open'
                                );
                            }
                        }
                    } else {
                        var contentDropdown =
                            dropdownButton.nextElementSibling;

                        if (
                            contentDropdown &&
                            !contentDropdown.contains(
                                event.target
                            ) &&
                            !dropdownButton.contains(
                                event.target
                            )
                        ) {
                            dropdownButton.setAttribute(
                                'aria-expanded',
                                false
                            );
                        }
                    }
                }
            );
        }
    }
}

// ================================================================
// PRAMOGH WEIGHT SORT — NON-INTRUSIVE STATE BRIDGE
// ================================================================
// IMPORTANT:
// This bridge NEVER overrides history.pushState/replaceState and NEVER
// intercepts native Shopify navigation. Native sort remains Shopify's job.
// It only remembers that Weight was explicitly selected during the current
// collection lifecycle so filter AJAX cannot mistake Shopify's temporary
// sort_by value for a user sort selection.
// ================================================================
(function () {
    const VALID = ['asc', 'desc'];

    function pathname() {
        return window.location.pathname;
    }

    function urlDirection(urlLike = window.location.href) {
        try {
            const url = new URL(urlLike, window.location.origin);
            const direction = url.searchParams.get('pramogh_weight_sort');
            return VALID.includes(direction) ? direction : null;
        } catch (error) {
            return null;
        }
    }

    function getDirection() {
        try {
            const state = window.__PRAMOGH_WEIGHT_STATE__;
            if (
                state &&
                state.pathname === pathname() &&
                state.active === true &&
                VALID.includes(state.direction)
            ) {
                return state.direction;
            }
        } catch (error) {}

        return urlDirection();
    }

    function set(direction) {
        if (!VALID.includes(direction)) return;

        window.__PRAMOGH_WEIGHT_STATE__ = {
            pathname: pathname(),
            active: true,
            direction: direction
        };
    }

    function clear() {
        // Explicit native sort selection is the ONLY operation allowed to
        // clear Weight ownership. Do not leave a stale direction behind.
        window.__PRAMOGH_WEIGHT_STATE__ = {
            pathname: pathname(),
            active: false,
            direction: null
        };
    }

    window.PramoghWeightController = {
        getDirection,
        set,
        clear,
        urlDirection
    };

    // Fresh page load: URL is authoritative. There is intentionally NO
    // sessionStorage fallback here. /collections/x must behave exactly like
    // Shopify when pramogh_weight_sort is absent.
    const initial = urlDirection();
    if (initial) set(initial);
})();

// ================================================================
// CUSTOM ELEMENT
// ================================================================

customElements.define(
    'toolbar-item',
    Toolbar
);